// frontend/src/components/EditSessionLogForm.tsx

import React from "react";
import SessionLogForm from "./SessionLogForm";
import {
  SessionLog,
  UpdateSessionLogRequest,
} from "../types/sessionLog";

interface Props {
  log: SessionLog;
  onSubmit: (
    id: string,
    data: UpdateSessionLogRequest,
  ) => Promise<void>;
  onCancel: () => void;
}

export default function EditSessionLogForm({
  log,
  onSubmit,
  onCancel,
}: Props) {
  // Reuse SessionLogForm so create/edit share exactly the same modal UI.
  const initial = {
    id: log.id,
    teacher: log.teacher,
    teacherName: log.teacherName,
    course: log.course.id,
    date: log.date.substr(0, 10),
    startTime: log.startTime,
    endTime: log.endTime,
    topicCovered: log.topicCovered,
    location: log.location,
    notes: log.notes,
  };

  const handleSubmit = async (formData: any) => {
    // Teacher remains read-only during edit and must not be included
    // in the update payload.
    const { teacher, ...payload } = formData;

    await onSubmit(
      log.id,
      payload as UpdateSessionLogRequest,
    );
  };

  return (
    <SessionLogForm
      initial={initial}
      onSubmit={handleSubmit}
      onCancel={onCancel}
    />
  );
}
